import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { generate } from 'shortid';
import { TableItem } from '..';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
    padding: 4
  },
  text: {
    fontSize: 9
  }
});

const commonStyles = {
  width: '100%',
  fontFamily: 'Noto Sans'
};

interface TableRowProps {
  items: TableItem[];
  showBorder?: boolean;
}

const TableRow: React.FC<TableRowProps> = ({ items, showBorder = false }) => {
  const hasMultiLineLabel = items.some(
    item => item.subtexts && item.subtexts.length > 0
  );

  return (
    <View
      style={[
        styles.container,
        {
          borderBottom: showBorder ? '1px solid #DFE2E7' : 'none',
          alignItems: hasMultiLineLabel ? 'center' : 'flex-start'
        }
      ]}
      wrap={false}
    >
      {items.map(item => (
        <View
          key={`table-cell-${generate()}`}
          style={{
            width: item.styles.width,
            paddingLeft: item.styles.paddingLeft
          }}
          wrap={false}
        >
          <Text style={[styles.text, item.styles, commonStyles]}>
            {item.label}
          </Text>
          {item.subtexts.map(subtext => {
            return (
              <Text
                key={`subtext-${generate()}`}
                style={[subtext.styles, commonStyles]}
              >
                {subtext.label}
              </Text>
            );
          })}
        </View>
      ))}
    </View>
  );
};

export default TableRow;
